// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","topicsChecklist":"topicsChecklist_topicsChecklist__SEbCn"};